import controller from '../../../cases/authorization-form/authorization-form.controller';
import template from '../../../cases/authorization-form/authorization-form.pug';

const AuthorizationFormComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  }
};

export default AuthorizationFormComponent;



// WEBPACK FOOTER //
// ./client/app/public/case/authorization-form/authorization-form.component.js